export const RESOURCES_FORMAT = [
    {
        "value": "FormatSite",
        "label": "Interactive website"
    },
    {
        "value": "FormatDown",
        "label": "Downloadable documents (Word, PDF, Slides)"
    },
    {
        "value": "FormatBook",
        "label": "Textbook / Picture book / eBook"
    },
    {
        "value": "FormatGame",
        "label": "Game"
    },
    {
        "value": "FormatPodcast",
        "label": "Podcast"
    },
    {
        "value": "FormatVideo",
        "label": "Video / Animation"
    },
    {
        "value": "FormatWorkshop",
        "label": "Offline seminar / Workshop"
    },
    {
        "value": "FormatWebinar",
        "label": "Webinar"
    },
    {
        "value": "FormatOthers",
        "label": "Others"
    }
    // {
    //     "value": "InteractiveWebsite",
    //     "label": "Interactive website"
    // },
    // {
    //     "value": "DownloadableDocument",
    //     "label": "Downloadable documents (Word, PDF, slides, etc.)"
    // },
    // {
    //     "value": "TextPictureEBook",
    //     "label": "Textbook / Picture book / eBook"
    // },
    // {
    //     "value": "Game",
    //     "label": "Game"
    // },
    // {
    //     "value": "Podcast",
    //     "label": "Podcast"
    // },
    // {
    //     "value": "VideoAnimation",
    //     "label": "Video / Animation"
    // },
    // {
    //     "value": "OfflineSeminarWorkshop",
    //     "label": "Offline seminar / Workshop"
    // },
    // {
    //     "value": "Webinar",
    //     "label": "Webinar"
    // },
    // {
    //     "value": "Others",
    //     "label": "Others"
    // }
];

export const RESOURCES_FORMAT_MAP = {
    "FormatSite": {
        "label": "Interactive website"
    },
    "FormatDown":{
        "label": "Downlodable documents"
    },
    "FormatBook":{
        "label": "Textbook / Picture book /"
    },
    "FormatGame":{
        "label": "Game"
    },
    "FormatPodcast":{
        "label": "Podcast"
    },
    "FormatVideo":{
        "label": "Video"
    },
    "FormatWorkshop":{
        "label": "Offline seminar / Workshop"
    },
    "FormatWebinar":{
        "label": "Webinar"
    },
    "FormatOthers":{
        "label": "Others"
    }
    // "InteractiveWebsite": {
    //     "label": "Interactive Website"
    // },
    // "DownloadableDocument": {
    //     "label": "Downloadable documents (Word, PDF, slides, etc.)"
    // },
    // "TextPictureEBook": {
    //     "label": "Textbook / Picture book / eBook"
    // },
    // "Game": {
    //     "label": "Game"
    // },
    // "Podcast": {
    //     "label": "Podcast"
    // },
    // "VideoAnimation": {
    //     "label": "Video / Animation"
    // },
    // "OfflineSeminarWorkshop": {
    //     "label": "Offline seminar / Workshop"
    // },
    // "WWebinar": {
    //     "label": "Webinar"
    // },
    // "Others": {
    //     "label": "Others"
    // }
};